import React from 'react'
import Question from 'components/Question'

/**
 * * 一番最初に回答する質問
 */
const Q1 = () => {
  return (
    <Question
      q={
        <>
          チュールなどの
          <br className="lg:hidden" />
          柔らかい素材感が好き？
        </>
      }
      routes={{
        yes: {
          index: 1, // 王道なデザインが好き？
        },
        no: {
          index: 3, // ボリュームのあるドレスが好き？
        },
      }}
    />
  )
}

export default Q1
